import { useEffect, useState } from 'react';

const RECAPTCHA_SCRIPT_ID = 'recaptcha-script';

interface RecaptchaHook {
    isLoaded: boolean;
    executeRecaptcha: (action: string) => Promise<string>;
}

export const useRecaptcha = (siteKey: string): RecaptchaHook => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!siteKey) {
        return undefined;
    }

    if (document.getElementById(RECAPTCHA_SCRIPT_ID)) {
      setIsLoaded(true);
      return undefined;
    }

    const script = document.createElement('script');
    script.id = RECAPTCHA_SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = (): void => {
      setIsLoaded(true);
    };

    document.head.appendChild(script);

    return (): void => {
      const existingScript = document.getElementById(RECAPTCHA_SCRIPT_ID);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, [siteKey]);

  const executeRecaptcha = async (action: string): Promise<string> => {
    if (!isLoaded || !window.grecaptcha) {
      throw new Error('reCAPTCHA not loaded');
    }

    const token = await window.grecaptcha.enterprise.execute(siteKey, { action });
    return token;
  };

  return {
    isLoaded,
    executeRecaptcha
  };
};
